import {HTMLElement, def, con, dis} from '@acng/frontend-bounty/dom/custom.js';
import {connect, disconnect} from '../service/size.js';

def(
  'onsw-section',
  class extends HTMLElement {
    [con]() {
      ASSERT: console.warn('onsw-section is deprecated in favor of [:responsive]', this);
      connect(this);
    }
    [dis]() {
      disconnect(this);
    }
  }
);
